import Rollbar from 'rollbar';

import { constants } from '../config';

const rollbarConfig = {
  accessToken: constants.rollbarToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: constants.environmentName,
    client: {
      javascript: {
        code_version: constants.version,
        guess_uncaught_frames: true,
        source_map_enabled: true,
      },
    },
  },
};

// eslint-disable-next-line import/no-mutable-exports
let rollbarInstance = null;
if (constants.rollbarToken) {
  rollbarInstance = new Rollbar(rollbarConfig);
}

export { rollbarInstance as Rollbar };



// WEBPACK FOOTER //
// ./src/helpers/Rollbar.js